<div class="po-row">
  <po-widget class="po-md-6" p-title="Risco das correções">
    <p class="po-font-display">{{ highReviewRateLabel }}<span class="po-icon po-icon-info review-stats-severity__help"
      [p-tooltip]="cardHelp.severity" p-tooltip-position="bottom" p-append-in-body="true"></span>
      <small class="review-stats-severity__unit">dos reviews exigem correção de alta gravidade</small></p>
    <!-- Subir é piorar: mais reviews pedindo correção grave. -->
    <po-tag *ngIf="highChange as change" class="review-stats-severity__tag"
      [p-type]="change.flat ? 'info' : (change.up ? 'danger' : 'success')"
      [p-value]="change.label + ' vs. período anterior'"></po-tag>

    <ng-container *ngIf="hasSeverity; else noSeverity">
      <!-- O alternador existe porque as duas leituras respondem perguntas diferentes, e
           "por review" é multi-valorado: sem dizer qual está no ar, o leitor somaria as
           barras e estranharia o resultado. -->
      <div class="review-stats-severity__toolbar">
        <div class="review-stats-severity__scope" role="group" aria-label="Base da contagem">
          <button type="button" [attr.aria-pressed]="!byReview" (click)="onScopeChange(false)">Por correção</button>
          <button type="button" [attr.aria-pressed]="byReview" (click)="onScopeChange(true)">Por review</button>
        </div>
        <div class="review-stats-severity__scope" role="group" aria-label="Valor exibido">
          <button type="button" [attr.aria-pressed]="severityMode === 'count'" (click)="severityMode = 'count'">Quantidade</button>
          <button type="button" [attr.aria-pressed]="severityMode === 'share'" (click)="severityMode = 'share'">%</button>
        </div>
      </div>

      <ul class="review-stats-severity__bars">
        <li *ngFor="let bar of severityBars">
          <span class="review-stats-severity__key">{{ bar.label }}</span>
          <span class="review-stats-severity__track">
            <span class="review-stats-severity__fill"
              [ngClass]="'review-stats-severity__fill--' + bar.modifier"
              [style.width.%]="barWidth(bar, severityMode)">
            </span>
          </span>
          <span class="review-stats-severity__value" [title]="bar.count + ' · ' + bar.share">{{ barText(bar, severityMode) }}</span>
        </li>
      </ul>

      <p class="review-stats-severity__note" *ngIf="byReview">
        Um review com achados de mais de uma severidade conta em cada uma — a soma passa
        do total de reviews.
      </p>

      <po-info p-label="Reviews com alta gravidade" [p-value]="reviewsWithHighLabel" p-orientation="horizontal"></po-info>
      <po-info p-label="Correções necessárias" [p-value]="requiredActionsLabel" p-orientation="horizontal"></po-info>
      <po-info
        *ngIf="hasVulnerabilities"
        p-label="Vulnerabilidades"
        [p-value]="vulnerabilitiesLabel"
        p-orientation="horizontal">
      </po-info>
    </ng-container>

    <ng-template #noSeverity>
      <p class="po-font-text-small">
        Sem ação obrigatória detalhada neste recorte — ou os reviews são anteriores a
        este controle, e o detalhamento ainda não foi preenchido.
      </p>
    </ng-template>
  </po-widget>

  <po-widget class="po-md-6" p-title="Resultado por arquivo">
    <p class="po-font-display">{{ scoreLabel }}<span class="po-icon po-icon-info review-stats-severity__help"
      [p-tooltip]="cardHelp.verdict" p-tooltip-position="bottom" p-append-in-body="true"></span>
      <small class="review-stats-severity__unit">de nota média por arquivo</small></p>

    <ng-container *ngIf="hasVerdict; else noVerdict">
      <div class="review-stats-severity__toolbar">
        <div class="review-stats-severity__scope" role="group" aria-label="Valor exibido">
          <button type="button" [attr.aria-pressed]="verdictMode === 'count'" (click)="verdictMode = 'count'">Quantidade</button>
          <button type="button" [attr.aria-pressed]="verdictMode === 'share'" (click)="verdictMode = 'share'">%</button>
        </div>
      </div>
      <ul class="review-stats-severity__bars">
        <li *ngFor="let bar of verdictBars">
          <span class="review-stats-severity__key">{{ bar.label }}</span>
          <span class="review-stats-severity__track">
            <span class="review-stats-severity__fill"
              [ngClass]="'review-stats-severity__fill--' + bar.modifier"
              [style.width.%]="barWidth(bar, verdictMode)">
            </span>
          </span>
          <span class="review-stats-severity__value" [title]="bar.count + ' · ' + bar.share">{{ barText(bar, verdictMode) }}</span>
        </li>
      </ul>

      <po-info
        *ngIf="hasBlocked"
        p-label="Reviews bloqueados"
        [p-value]="blockedLabel"
        p-orientation="horizontal">
      </po-info>
      <!-- Fora das barras de propósito: mede falha do assistente, não qualidade do
           código. Ver `cardHelp.verdict`. -->
      <po-info
        *ngIf="hasInvalidAnswers"
        p-label="Sem resultado válido"
        [p-value]="invalidAnswersLabel"
        p-orientation="horizontal">
      </po-info>
      <po-info
        *ngIf="hasUnknownFiles"
        p-label="Sem detalhamento"
        [p-value]="unknownFilesLabel"
        p-orientation="horizontal">
      </po-info>
    </ng-container>

    <ng-template #noVerdict>
      <p class="po-font-text-small">
        Nenhum arquivo com veredito neste recorte. Reviews anteriores a este controle
        aparecem aqui depois do preenchimento do histórico.
      </p>
    </ng-template>
  </po-widget>
</div>
